import { useState, useEffect } from "react";
import {
  IGetEditingResultMsg,
  IGetEditingResultsData,
  getQuickEditingTimelineId,
} from "@/services/quick-videoallyis";
import {
  toTimeLineGetDuration,
} from "@/utils/mixCutResult";
import {
  CreateEngineeringResponse,
  toIdGetEngineer,
  toIdGetEngineerContent,
} from "@/services/createSpace/engineering";
import { getEditingTimelineId } from '@/services/quick-videoallyis';
import useMixCutDetailPreview from "@/useStore/mixCutDetailPreview/useMixCutDetailPreview";
import { Message } from "@arco-design/web-react";
import { teamVideoMixCutCount } from "@/services/mixCutDetail/mixCutDetail";
import QuickCutStore from "@/stores/quickCutStore";
type UseEditingResultsType = IGetEditingResultsData & {
  title: string;
  time: string;
};

export interface IUseEditingResultsReturn {
  data: UseEditingResultsType[];
  msg: CreateEngineeringResponse;
  resultMsg: IGetEditingResultMsg;
  loading: boolean;
  error: string;
  count: number;
  setData: (data: any[]) => void;
}

const useEditingResults = (
  projectId: string,
  outputCount: number,
): IUseEditingResultsReturn => {
  const {
    data,
    handlePreviewItemAdd,
    handlePreviewClear,
    handlePreviewChange,
  } = useMixCutDetailPreview();
  const [msg, setMsg] = useState<CreateEngineeringResponse>(null);
  const [count, setCount] = useState<number>(null);
  const [resultMsg, setResultMsg] = useState<IGetEditingResultMsg>(null);
  const [error, setError] = useState<string>(null);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    // let isFirstDataPushed = false; // 标志变量，记录是否推送了第一条数据
    setLoading(true);
    try {
      const [message, content] = await Promise.all([
        toIdGetEngineer(Number(projectId)),
        toIdGetEngineerContent(Number(projectId)),
      ]);
      setMsg(message);
      try {
        const jsonData = JSON.parse(content);
        if (jsonData.settings.general.mode === 'custom') {
          jsonData.scenes = jsonData.scenes.map(item => {
            return {
              ...item,
              duration: item.duration * 1000
            }
          })
        }
        for await (const result of getQuickEditingTimelineId({
          project_id: Number(message.project_id),
          session_id: Number(projectId),
          aspectRadio: message.aspect,
          data: JSON.stringify(jsonData),
          outputCount: outputCount,
        })) {
          if (result.event === 'item') {
            console.log('处理进度:', result);
            QuickCutStore.preivewData.push(result.data)
            QuickCutStore.preivewData = QuickCutStore.preivewData.map(item => {
              item.time = toTimeLineGetDuration(item.timeline);
              item.title = item?.title ? ((item?.title || '') + (item?.title  ? `,${item?.word_title}` : item?.word_title) + (item?.word_title ? `,${item.word_topics}` : item.word_topics)) : ''
              return item;
            })
            console.log(JSON.stringify(QuickCutStore.preivewData));
            // handlePreviewChange([...(data || []), result.data]);
          } else if (result.event === 'complete') {
            console.log('处理完成:', result.data);
          }
        }
        setLoading(false);
      } catch (err) {
        try {
          console.log("err", err);
          const error = JSON.parse(`${err}`).message;
          setError(error.split("=")[2]);
          Message.error(error.split("=")[2]);
        } catch (e) {
          setError(err);
          Message.error(err);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("获取编辑结果出错:", error);
      handlePreviewClear();
    }
  };

  const getTeamCount = async () => {
    try {
      const info = await teamVideoMixCutCount();
      const type = (info?.infos || []).find((item) => item?.type == 1).type;
      const count = (info?.items || []).find(
        (item) => item?.benefit_type === type,
      )?.total;
      setCount(count || 0);
    } catch (e) {
      setCount(0);
      console.log(e);
    }
  };

  useEffect(() => {
    // fetchData();
    getTeamCount();
  }, [projectId]);

  return {
    count,
    data,
    msg,
    resultMsg,
    loading,
    error,
    setData: handlePreviewChange,
  };
};

export default useEditingResults;
